import { Perm, State } from '../../../../../constants/assignment-permissions'

export const ContentRules = {
    EDIT_NAMINGS: [
        Perm.CAN_EDIT,
        State.NOT_MBA
    ],
    EDIT_GRADINGS: [
        Perm.CAN_EDIT,
        State.NOT_PROCESSING,
        State.UNPUBLISHED,
        State.NOT_MBA
    ]
}

export const TextContentRules = {
    EDIT_NAMINGS: [
        ...ContentRules.EDIT_NAMINGS,
        State.LATEST,
    ],
    EDIT_GRADINGS: [
        ...ContentRules.EDIT_GRADINGS,
        State.LATEST,
    ],
}


